/* assets/ssuk-cl.js - SSUK, 27 Sept 2026. Collection page redesign (DEC-0076).
   Read more on the two-line collection intro. The button only shows when the text is actually clamped. */
(function () {
  function initIntro(root) {
    (root || document).querySelectorAll('.js-cl-intro').forEach(function (intro) {
      var btn = intro.parentElement.querySelector('.js-cl-intro-toggle');
      if (!btn) return;
      if (!intro.classList.contains('is-open')) btn.hidden = !(intro.scrollHeight - intro.clientHeight > 2);
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var open = intro.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initIntro(); });
  } else {
    initIntro();
  }
  window.addEventListener('load', function () { initIntro(); });

  /* Sector chips stay in step with the grid. The theme's filters swap #filter-results in place without a
     reload; when that happens, fetch this section again for the same URL and swap in its chips. */
  var subnav = document.querySelector('[data-cl-subnav]');
  var results = document.getElementById('filter-results');
  if (subnav && results && window.MutationObserver) {
    var lastUrl = location.href;
    var pending = null;
    var refreshChips = function () {
      if (location.href === lastUrl) return;
      lastUrl = location.href;
      var url = new URL(location.href);
      url.searchParams.set('section_id', subnav.dataset.clSubnav);
      if (pending) pending.abort();
      pending = new AbortController();
      fetch(url.toString(), { signal: pending.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.ssuk-cl-sec--sectors');
          var current = subnav.querySelector('.ssuk-cl-sec--sectors');
          if (current && fresh) current.replaceWith(fresh);
          else if (current && !fresh) current.remove();
          else if (!current && fresh) subnav.querySelector('.container').appendChild(fresh);
          /* keep the active filters when a buyer then taps a sector */
          subnav.querySelectorAll('.ssuk-cl-sec--sectors a.ssuk-cl-chip').forEach(function (a) {
            var u = new URL(a.href, location.origin);
            new URL(location.href).searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by') u.searchParams.append(k, v); });
            a.href = u.pathname + u.search;
          });
        })
        .catch(function () {});
    };
    new MutationObserver(function () { setTimeout(refreshChips, 50); }).observe(results, { childList: true });
  }

  /* Show more / Show fewer on the Sector and Type filter groups (six shown, DEC-0076). Delegated, so it
     keeps working after the theme re-renders the filter form. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-cl-more');
    if (!btn) return;
    var list = btn.previousElementSibling;
    if (!list) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    list.querySelectorAll('.ssuk-cl-more-item').forEach(function (li) { li.hidden = open; });
    btn.setAttribute('aria-expanded', String(!open));
    btn.textContent = open ? btn.dataset.more : 'Show fewer';
  });
})();
